<template>
  <v-container fluid>
    <page-header
      title="로그인 현황"
      :useList="buttonUseList"
      :usePermission="false"
      @btnSearch="retrieve"
    />
    <v-row>
      <v-col class="py-2">
        <v-card class="px-4">
          <v-row>
            <v-col cols="12" md="4">
              <!-- 아이디 -->
              <v-text-field dense outlined hide-details :label="$t('id')" v-model="retrieveData.userId" @keyup.enter="retrieve" class="user_id-tf">
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="retrieveData.date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    v-model="rangeText"
                    :label="$t('period')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="retrieveData.date"
                  no-title
                  scrollable
                  range
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="changeDatePicker"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="justify-end">
      <v-col cols=12>
        <v-btn small outlined class="excel_down default-btn" @click="excelDown">
          {{ $t('label.download-excel') }}
        </v-btn>
      </v-col>
      <v-col>
        <real-grid
          ref="dataGrid"
          class="mt-1 mb-5 w-full"
          :options="grid.gridOption"
          :fields="grid.gridFields"
          :columns="grid.gridColumns"
          :height="grid.height"
          :retrieve-api="gridRetrieveApi"
          :retrieve-data="retrieveData"
        ></real-grid>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import day from 'dayjs'
import DispatchResize from '@/mixins/DispatchResize'
import PageHeader from '@/layout/components/PageHeader'
import RealGrid from '@/components/grid/Realgrid'
import { searchLoginHistory } from '@/api/manager/log/logManagement'

export default {
  name: 'LoginLog',
  components: {
    PageHeader,
    RealGrid
  },
  mixins: [DispatchResize()],
  data() {
    return {
      menu: false,
      buttonUseList: [
        'btnSearch'
      ],
      retrieveData: {
        date: [],
        userId: ''
      },
      clientTypeList: [
        {
          value: 'A',
          label: 'Android'
        },
        {
          value: 'W',
          label: 'WEB'
        },
        {
          value: 'I',
          label: 'IOS'
        },
        {
          value: 'E',
          label: '기타'
        }
      ],
      grid: {
        height: 450,
        gridOption: {
          gridView: {
            edit: {
              appendable: false,
              insertable: false,
              deletable: false,
              editable: false
            },
            setGroupingOptions: {
              enabled: false // header 그룹핑 옵션을 사용하지 않는다.
            },
            checkBar: {
              visible: false
            },
            panel: {
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            },
            rowIndicator: {
              visible: false
            },
            stateBar: {
              visible: false
            }
          },
          dataProvider: {
            softDeleting: true,
            // 해당 옵션이 false 이면 추가된 행을 삭제했을 경우 -+ 표시가 생긴다.
            // true 이면 추가된 행은 바로 삭제, 기존에 존재하던 행은 - 표시
            deleteCreated: true
          }
        },
        gridTotal: 0,
        gridFields: [
          {
            fieldName: 'loginDate',
            dataType: 'string'
          },
          {
            fieldName: 'userId',
            dataType: 'string'
          },
          {
            fieldName: 'sessionId',
            dataType: 'string'
          },
          {
            fieldName: 'clientIp',
            dataType: 'string'
          },
          {
            fieldName: 'clientType',
            dataType: 'string'
          },
          {
            fieldName: 'logoutDate',
            dataType: 'string'
          },
          {
            fieldName: 'successYn',
            dataType: 'string'
          },
          {
            fieldName: 'errorMsg',
            dataType: 'string'
          }
        ],
        gridColumns: []
      }
    }
  },
  created() {
    this.retrieveData.date.push(day().add(-3, 'day').format('YYYY-MM-DD'))
    this.retrieveData.date.push(day().format('YYYY-MM-DD'))
    this.retrieveData.startDate = day(this.retrieveData.date[0]).format('YYYYMMDD')
    this.retrieveData.endDate = day(this.retrieveData.date[1]).format('YYYYMMDD')
    this.createGridColumn()
  },
  async mounted() {
    this.retrieve()
  },
  computed: {
    rangeText() {
      return this.retrieveData.date.join('~')
    },
    gridRetrieveApi() {
      return searchLoginHistory
    }
  },
  methods: {
    // 조회 버튼 클릭 시 실행
    // 엑셀다운로드 클릭 시 실행
    createGridColumn() {
      this.grid.gridColumns = [
        {
          name: 'loginDate',
          fieldName: 'loginDate',
          header: {
            text: '로그인 시간'
          },
          width: 150,
          editable: false
        },
        {
          name: 'userId',
          fieldName: 'userId',
          header: {
            text: '아이디'
          },
          width: 100,
          editable: false
        },
        {
          name: 'sessionId',
          fieldName: 'sessionId',
          header: {
            text: '세션 ID'
          },
          width: 250,
          editable: false
        },
        {
          name: 'clientIp',
          fieldName: 'clientIp',
          header: {
            text: 'IP'
          },
          width: 100,
          editable: false
        },
        {
          name: 'clientType',
          fieldName: 'clientType',
          header: {
            text: '클라이언트 타입'
          },
          lookupDisplay: true,
          values: this.clientTypeList.map(item => item.value),
          labels: this.clientTypeList.map(item => item.label),
          width: 100,
          editable: false
        },
        {
          name: 'logoutDate',
          fieldName: 'logoutDate',
          header: {
            text: '로그아웃 시간'
          },
          width: 150,
          editable: false
        },
        {
          name: 'successYn',
          fieldName: 'successYn',
          header: {
            text: '성공유무'
          },
          width: 100,
          editable: false
        },
        {
          name: 'errorMsg',
          fieldName: 'errorMsg',
          header: {
            text: '에러메시지'
          },
          width: 300,
          editable: false
        }
      ]
    },
    excelDown() {
      // 엑셀다운로드 클릭시 실행
      this.$refs.dataGrid.excelDown()
    },
    retrieve() {
      this.$refs.dataGrid.retrieve()
    },
    changeDatePicker() {
      if (this.retrieveData.date) {
        if (day(this.retrieveData.date[0]).isBefore(day(this.retrieveData.date[1]))) {
          this.retrieveData.startDate = day(this.retrieveData.date[0]).format(
            'YYYYMMDD'
          )
          this.retrieveData.endDate = day(this.retrieveData.date[1]).format(
            'YYYYMMDD'
          )
        } else {
          this.retrieveData.startDate = day(this.retrieveData.date[1]).format(
            'YYYYMMDD'
          )
          this.retrieveData.endDate = day(this.retrieveData.date[0]).format(
            'YYYYMMDD'
          )
        }
        this.$refs.menu.save(this.retrieveData.date)
      } else {
        this.retrieveData.startDate = ''
        this.retrieveData.endDate = ''
        this.menu = false
      }
    }
  },
  beforeDestroy() {
    // 리얼그리드 데이터 지우기
    if (this.$refs.dataGrid) {
      this.$refs.dataGrid.destroy()
    }
  }
}
</script>

<style scoped>
.realgrid_style {
  height: 400px;
}
</style>

<style lang="scss">
.user_id-tf {
  .v-input__append-outer {
    margin: 0px 0px 0px 4px !important;
  }
}
</style>
